import React, { useEffect, useState } from 'react'
import CategoryBox from '../components/CategoryBox'
import api from '../controller/api'
import Loading from '../components/Loading'

export default function Category() {
    const [salonCategories, setSalonCategories] = useState([])
    const [pageLoading, setPageLoading] = useState(false)

    const fetchCategory = async () => {
        try {
            const { data: res } = await api.get("/category/list")
            setSalonCategories(res.data)
        } catch (error) {
            console.error(error?.response?.data?.message);
            if (error?.response?.data?.message === "jwt expired") {
                localStorage.removeItem("user");
                window.location.reload();
            }
        } finally {
            setPageLoading(false)
        }
    }

    useEffect(() => {
        setPageLoading(true)
        fetchCategory()
    }, [])

    if (pageLoading) return <Loading />
    return (
        <div className='category-list'>
            <h2>What are you looking for, Bestie? 👀</h2>
            <div className='category-manage'>
                {salonCategories.map((salon) => salon.status === true && <CategoryBox key={salon._id} salon={salon} />)}
            </div>
        </div>
    )
}
